export function PanelLoading({ message = 'Loading...' }: { message?: string }) {
  return (
    <div className="flex h-full items-center justify-center text-xs text-muted-foreground">
      {message}
    </div>
  )
}
